import { useEffect } from "react";
import { getAuth, Unsubscribe } from "firebase/auth";
import firebase from "app/Auth";
import { useDialog } from "app/hook";
import { DialogType } from "app/types";
import { getEnv } from "app/configSlice";
import parentI18n from "features/shared/i18n";
import { createParentAccount } from "features/account/api";
import { mapLocaleToLanguage } from "./useAuthLocale";

export const useSignUp = () => {
  const handleDialog = useDialog();

  useEffect(() => {
    let unsubscribe: Unsubscribe;

    try {
      const auth = getAuth(firebase);
      unsubscribe = auth.beforeAuthStateChanged(async (user) => {
        try {
          if (user) {
            let email: string;
            if (
              user.providerData[0].providerId === "google.com" ||
              user.providerData[0].providerId === "apple.com"
            ) {
              email = user.providerData[0].email;
            } else {
              email = user.email;
            }
            await createParentAccount({
              user: {
                uid: user.uid,
                child_uid: null,
                email: email,
                provider: user.providerData[0].providerId,
                display_name: parentI18n.t("MSG_PARENTS_PROFILE_DEFAULT_NAME"),
                language: mapLocaleToLanguage(parentI18n.locale),
                env: getEnv(),
                timezone: "Asia/Tokyo",
                country: "ja",
              },
            });
          }

          unsubscribe();
        } catch (error) {
          console.error(error);
          unsubscribe();
          handleDialog({ type: DialogType.ERROR_NETWORK, value: true });
        }
      });
    } catch {
      handleDialog({ type: DialogType.ERROR_NETWORK, value: true });
    }
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
